import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointManualReviewData, type EnrollmentJointManualReviewSubmitOutput } from '../../../../models'

export const getEnrollmentJointManualReviewDataMock: EnrollmentJointManualReviewData = {
  activePerson: {
    applicationId: '305802305',
    path: '/enrollment/joint/manual-review',
    progress: 75,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
  },
  isError: false,
  errors: [],
}

export const submitEnrollmentJointManualReviewDataMock: EnrollmentJointManualReviewSubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/disclosures',
  },
}

export const mockGetEnrollmentJointManualReviewData = graphql.mutation('getEnrollmentJointManualReviewData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointManualReviewDataMock } })
})

export const mockSubmitEnrollmentJointManualReviewData = graphql.mutation(
  'submitEnrollmentJointManualReviewData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointManualReviewDataMock } })
  },
)

export const mockEnrollmentJointManualReview = [
  mockGetEnrollmentJointManualReviewData,
  mockSubmitEnrollmentJointManualReviewData,
]
